export default __webpack_public_path__ + "static/backgroundMainIntro-86c2a2ed4df71e321de1ba043b3831d6.svg";